import Service from "../../Services";

const Faq = {
    namespaced: true,
    state: {
        faqs: null,
    },
    mutations: {
        setFaqs: (state, res) => {
            state.faqs = res;
        }
    },
    actions: {
        onGetAllFaqs({ commit }, lang) {
            return Service.FaqAPI.getAllFaqs(lang).then(res => {
                commit('setFaqs', res);
            });
        }

    },
};

export default Faq
